import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'grievance_handling_dispute_resolution_procedures_accessible_some'

export const dataPointDefinition = {
  retracedId: 'grievance_handling_dispute_resolution_procedures_accessible_some',
  name: 'Grievance handling and dispute resolution procedures are accessible in some languages spoken at the facility, but not al',
  description: '',
  meta: {
    slcpMeta: {
      key: 'gr-1--2-2x',
      number: 'WI-GRI-2-2',
      dataType: 'boolean',
      masterType: 'Question',
      multiSelectKey: 'wi-gri-3',
      optionList: 'ms',
      versionImported: '1.7.0',
      verificationTypeReq: 'base-verf',
      verificationSelectionOptList: 'verf-a-list',
      nonComOptionList: 'lf',
      nonCompliance: '',
      humanShowHide: '[2],gr-1,Yes',
      machineShowHide: '[2],gr-1,1',
      completionCondition: 'any ms',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [
    {
      id: 'ms',
      name: 'ms',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'gr-1--2-2x', version: '1.7.0', provider: 'slcp'}],
  sortingId: 29090,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
